module.exports = __webpack_public_path__ + "img/VP-ProfiNew_Overview-Front_2.74cd7983.jpg";